export default __webpack_public_path__ + "static/media/vsc_vs.ad874fc7.jpg";